import ChatMessage, { ChatMessageTypes } from "../domain/chat-message"
import Codec from "./codec"

interface ChatMessageData {
  type: ChatMessageTypes
  user_id: string
  display_name: string
  text: string
  timestamp?: string
}

// eslint-disable-next-line import/no-default-export
export default class ChatMessageCodec extends Codec {
  encode(value: ChatMessage): ChatMessageData {
    return {
      type: value.type,
      user_id: value.userId,
      display_name: value.displayName,
      text: value.text,
      timestamp: value.timestamp?.toISOString(),
    }
  }

  decode(value: ChatMessageData | null, key: string): ChatMessage | null {
    if (value) {
      return new ChatMessage(
        key,
        value.type,
        value.user_id,
        value.display_name,
        value.text,
        value.timestamp,
      )
    }
    return null
  }
}
